import { RijdtGroepMaatregel } from "@/entities/vsm";
import { TreinserieDisplay } from "@/features/infra";
import { useMaatregelContext } from "@/features/vsm/maatregel-context";
import { ActionsDropdown, Button, DropdownMenuItem, Icon } from "@/shared/components";

type RijdtGroepBewerkenProps = {
    maatregel: RijdtGroepMaatregel;
};

export function RijdtGroepBewerken({ maatregel }: Readonly<RijdtGroepBewerkenProps>) {
    const { deleteMaatregel, startEdit, cancel } = useMaatregelContext();

    // Render a list of badges, one for each maatregel / treinserie.
    return (
        <div className="flex max-h-10 w-full flex-row items-center gap-2 py-2">
            <Icon name="train" />
            <div className="flex w-full min-w-0 flex-row flex-wrap">
                {maatregel.maatregelen.map((m) => (
                    <div key={m.id} className="text-m text-content-emphasis font-medium">
                        <TreinserieDisplay nummer={m.treinserie} />
                        <ActionsDropdown data-testid="rijdt-groep" iconSize="xs">
                            <DropdownMenuItem onSelect={() => startEdit(m)}>Maatregel bewerken</DropdownMenuItem>
                            <DropdownMenuItem onSelect={() => deleteMaatregel(m.id)}>Maatregel verwijderen</DropdownMenuItem>
                        </ActionsDropdown>
                    </div>
                ))}
            </div>
            <Button
                iconOnly
                icon="check"
                variant="tertiary"
                size="s"
                iconSize="m"
                title="Klaar met bewerken"
                onClick={() => cancel(maatregel)}
            />
        </div>
    );
}
